/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PickerLayout } from 'payments-lib';
import FavouritesActionCreator from '../../actions/AccountsActionCreator/FavouritesActionCreator';
import envConfig from '../../../static/config';
import AccountsStore from '../../stores/AccountsStore';
import AccountPickerModal from './AccountPickerModal';
import ApiUtils from '../../utils/ApiUtils';
import { ACCOUNT_PICKER_LAYOUT } from '../../constants/LargeCustomerViewConstants';
import InternetBankingActions from '../../actions/InternetBankingActions';

const getSessionData = (session) => {
  return {
    clientContext: ApiUtils.getApiClientContext(),
    accessToken: session.accessToken,
    bankId: ApiUtils.getBankId(),
  };
};

const addToAccountsStore = (account) => {
  FavouritesActionCreator.addSelectedAccount(account);
  AccountsStore.setAccountDetailsBalance();
};

class AccountPickerWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showErrorModal: false,
    };
    this.handleTooManyFavourites = this.handleTooManyFavourites.bind(this);
    this.handleModalClosed = this.handleModalClosed.bind(this);
    this.handleSelectAccount = this.handleSelectAccount.bind(this);
    this.handleRoute = this.handleRoute.bind(this);
  }

  handleTooManyFavourites() {
    this.setState({
      showErrorModal: true,
    });
  }

  handleModalClosed() {
    this.setState({
      showErrorModal: false,
    });
  }

  handleSelectAccount(account) {
    addToAccountsStore(account);
    const { onSelectAccount } = this.props;
    onSelectAccount(account);
  }

  handleRoute(route) {
    InternetBankingActions.navigateToWebTask(route);
  }

  render() {
    const { favourites, user, session, content } = this.props;

    return (
      <div className="web-ui-components">
        <PickerLayout
          session={getSessionData(session)}
          envConfig={envConfig}
          user={user}
          favourites={favourites}
          onSelectAccount={this.handleSelectAccount}
          onAddFavourite={FavouritesActionCreator.addFavouriteAccount}
          onRemoveFavourite={FavouritesActionCreator.removeFavouriteAccount}
          onTooManyFavourites={this.handleTooManyFavourites}
          layoutType={ACCOUNT_PICKER_LAYOUT}
          handleRoute={this.handleRoute}
        />
        <AccountPickerModal
          content={content}
          showErrorModal={this.state.showErrorModal}
          onModalClosed={this.handleModalClosed}
        />
      </div>
    );
  }
}

AccountPickerWrapper.propTypes = {
  favourites: PropTypes.array.isRequired,
  session: PropTypes.object.isRequired,
  user: PropTypes.shape({ id: PropTypes.string }),
  content: PropTypes.object.isRequired,
  onSelectAccount: PropTypes.func.isRequired,
};

export default AccountPickerWrapper;
